import React from 'react';
import { AdminAudit } from '@/components/admin/AdminAudit';
import { useAdminFilter } from '@/contexts/AdminFilterContext';

const AdminAuditPage = () => {
  const { userTypeFilter } = useAdminFilter();

  return <AdminAudit userTypeFilter={userTypeFilter} />;
};

export default AdminAuditPage;
